unable to read source [project]/repos/src/scraping/targets/ecommerce/utils.ts